module.exports = __webpack_public_path__ + "media/assets/avia/search/businessman-00ddf8d01d9f6ecb816798c17b228f0d.png";